import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Radio, RadioGroup, Input } from '@fluentui/react-components';
import { useAccessReviewStyles } from '../styles';

interface PublicTitleSectionProps {
    publicTitleOption: string;
    onPublicTitleOptionChange: (value: string) => void;
    manualPublicTitle: string;
    onManualPublicTitleChange: (value: string) => void;
}

export const PublicTitleSection: React.FC<PublicTitleSectionProps> = ({
    publicTitleOption,
    onPublicTitleOptionChange,
    manualPublicTitle,
    onManualPublicTitleChange,
}) => {
    const { t } = useTranslation();
    const styles = useAccessReviewStyles();

    return (
        <div className={styles.accessReviewFlexColumnWithGap}>
            <Field label={t('Public Title')}>
                <RadioGroup
                    value={publicTitleOption}
                    onChange={(_, data) => onPublicTitleOptionChange(data.value)}
                >
                    <Radio value="equal" label={t('Set equal to Title')} />
                    <Radio value="manual" label={t('Type manually')} />
                </RadioGroup>
            </Field>

            {publicTitleOption === 'manual' && (
                <Field>
                    <Input
                        placeholder={t('Enter public title')}
                        value={manualPublicTitle}
                        onChange={(_, data) => onManualPublicTitleChange(data.value)}
                    />
                </Field>
            )}
        </div>
    );
};
